<script>
    import {updatePlanPoi, deletePlanPoi} from '@js/actions/poiActions';

    import {poiStore} from '@js/stores/poiStore';

    import I18n from '@js/modules/translations';

    import Autocompletion from '@js/components/search/Autocompletion.svelte';

    import PlanMap from '@js/components/maps/PlanMap.svelte';
    import PlanModal from '@js/components/plan/PlanModal.svelte';
    import PlanList from '@js/components/plan/list/PlanList.svelte';
    import PlanFilters from '@js/components/plan/filter/PlanFilters.svelte';

    const {
        allFilters
    } = $props();

    let isModalOpen = $state(false);
    let planPoiCoordinates = $state(null);
    let currentPlanPoi = $state(null);
    let currentPlanRide = $state(null);

    const onSearchSubmit = (selectedLocation) => {
        poiStore.mapLocation = selectedLocation;
    };

    const _handlePoiAdded = (coordinates) => {
        planPoiCoordinates = coordinates;
        currentPlanPoi = null;
        currentPlanRide = null;

        isModalOpen = true;
    };

    const _handlePoiMoved = (coordinates, planPoi) => {
        return updatePlanPoi(planPoi.id, {
            poi: {
                latitude: coordinates.lat,
                longitude: coordinates.lng
            }
        }, false)
            .then((response) => {
                if (!response.errors) {
                    poiStore.planPois = poiStore.planPois.replaceOrAdd('id', response.poi);
                    poiStore.map.fetchPlanPOIs(poiStore.selectedFilters);

                    return response;
                }
            });
    };

    const _handlePoiRemoved = (removedPanPoi) => {
        return deletePlanPoi(removedPanPoi.id)
            .then((response) => {
                if (!response.errors) {
                    poiStore.planPois = poiStore.planPois.filter((planPoi) => planPoi.id !== removedPanPoi.id);
                    poiStore.map.fetchPlanPOIs(poiStore.selectedFilters);

                    return response;
                }
            });
    };

    const _handlePoiEdit = (planPoi) => {
        planPoiCoordinates = {
            lat: planPoi.coordinates[0],
            lng: planPoi.coordinates[1]
        };
        currentPlanPoi = planPoi;
        currentPlanRide = planPoi.associatedRides[0];

        isModalOpen = true;
    };
</script>

<Autocompletion id="global-search"
                placeholder={I18n.t('js.ride.plan.index.search')}
                searchFeatures={['location']}
                useFirstQueryOnEnter={false}
                onSubmit={onSearchSubmit}/>

<PlanFilters allFilters={allFilters}/>

<PlanMap mapId="plan-rides"
         onPoiAdded={_handlePoiAdded}
         onPoiMoved={_handlePoiMoved}
         onPoiEdit={_handlePoiEdit}
         onPoiRemoved={_handlePoiRemoved}/>

<PlanList/>

<PlanModal bind:isModalOpen={isModalOpen}
           planPoiCoordinates={planPoiCoordinates}
           planPoi={currentPlanPoi}
           planRide={currentPlanRide}/>
